import { useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  Modal,
  Switch,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useCreatePackagesPrice } from "@/features/packages-price/use-packages-prices.ts";

interface IFormInput {
  isActive: boolean;
  name: string;
  description: string;
  image: string;
  price: number;
}

export function CreatePackagesPricesModal() {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync, isPending } = useCreatePackagesPrice();

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    mutateAsync({
      isActive: data.isActive,
      name: data.name.trim(),
      description: data.description.trim(),
      image: data.image.trim(),
      price: Number(data.price),
    }).then(() => {
      reset();
      setIsOpen(false);
    });
  };

  return (
    <div>
      <Button
        variant="primary"
        onPress={() => setIsOpen(true)}
      >
        Создать
        <Icon className="size-6" icon="solar:add-circle-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                  <Modal.Heading>Добавить новую упаковку</Modal.Heading>
                </Modal.Header>
                <Modal.Body>
                  <TextField isInvalid={!!errors.name?.message}>
                    <Label>Название</Label>
                    <Input {...register("name", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.name?.message}</FieldError>
                  </TextField>

                  <TextField isInvalid={!!errors.description?.message}>
                    <Label>Описание</Label>
                    <Input {...register("description", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.description?.message}</FieldError>
                  </TextField>

                  <TextField isInvalid={!!errors.image?.message}>
                    <Label>Изображение</Label>
                    <Input {...register("image", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.image?.message}</FieldError>
                  </TextField>

                  <TextField isInvalid={!!errors.price?.message}>
                    <Label>Цена</Label>
                    <Input {...register("price", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.price?.message}</FieldError>
                  </TextField>

                  <Controller
                      control={control}
                      name="isActive"
                      defaultValue={true}
                      render={({ field }) => (
                          <Switch isSelected={field.value} onChange={field.onChange}>
                            <Switch.Control>
                              <Switch.Thumb />
                            </Switch.Control>
                            <Switch.Content>
                              <Label>Активно</Label>
                            </Switch.Content>
                          </Switch>
                      )}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button
                      variant="danger-soft"
                      onPress={() => setIsOpen(false)}
                  >
                    Отмена
                  </Button>

                  <Button variant="primary" isPending={isPending} type="submit">
                    Создать
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
